import { useL10n } from "@ews/react-localization-context";

import { FC } from "react";
import
{
    MenuLink,
    MenuSpacer,
    Sidebar,
    SidebarSection
} from "./Sidebar";

import
{
    RouteParams,
    useNamedRoutes
} from "../../NamedRoutes";


import type {
    MenuToggleProps
} from "../types";

import
{
    useMyPermissions,
    useMyProfile
} from "../../Login/LoginProvider";

import
{
    User,
    UserPermissions,
    permissionAllowed
} from "@ews/react-data";

import Icon from "@ews/react-icons";
import NewCustomerModal from "../../Customer/NewCustomer/NewCustomerModal";
import { useDoubleConfirmDialog } from "../../Dialog";
import { useCustomer, useRemoveCustomer } from "../../ReactData/customer";
import NewSystemModal from "../../System/NewSystem/NewSystemModal";
import { ReactClickEvent } from "../../types";
import NewUserModal from "../../User/NewUser/NewUserModal";

type SidebarProps = MenuToggleProps & {
    routeParams?: RouteParams;
};

const uuidToLTree = (uuid: string) => uuid.replace(/-/g, '_');

const Customer: FC<SidebarProps> = ({
    routeParams = {},
    onMenuToggle,

}) =>
{
    const { translate: t } = useL10n();
    const { generate, params, router } = useNamedRoutes();
    const { id: customerId } = routeParams;
    const customer = useCustomer(customerId || "");
    const permissions: UserPermissions = useMyPermissions();
    const me: User = useMyProfile();
    const dialog = useDoubleConfirmDialog();
    const removeCustomer = useRemoveCustomer();

    //title = title || t("[REACT_CUSTOMERSETTINGS]");

    const mayDelete = !(me.tree || "").split(".").includes(uuidToLTree(customerId || params().id || "")) && !customer.children;

    const handleDelete = async (e: ReactClickEvent) =>
    {
        if (!customerId) return;

        const response = await dialog({
            title: t("[REACT_REMOVE_CUSTOMER]"),
            message: t("[CONFIRM_REMOVE_CUSTOMER]"),
            areYouSureButtonTitle: t("COM_TEMPLATES_ARE_YOU_SURE"),
            confirmButtonTitle: t("COM_FACPMANAGEMENT_REGRESSION_STATUS_OK"),
            cancelButtonTitle: t("COM_BANNERS_CANCEL")
        });

        if (response) {
            // await removeCustomer(customerId);
            // onMenuToggle && onMenuToggle(e);
            // const redirect = generate('customers');
            // router?.push(redirect);
        }

    };


    return (
        <Sidebar onMenuToggle={onMenuToggle}>
            <SidebarSection grow>
                {permissionAllowed(permissions.createCustomer!) ? <MenuLink
                    title={t('[SID_MNU_TAB_SETTINGS]')}
                    onClick={onMenuToggle}
                    link={generate('customer', routeParams)}
                    icon={<Icon icon="settings" />}
                /> : <></>}


                {permissionAllowed(permissions.createCustomer!) ? <>
                    {/* <MenuLink
                    title={t('[REACT_CREATE_CUSTOMER]')}
                    onClick={onMenuToggle}
                    link={generate('customer:addcustomer', routeParams)}
                    icon={peopleOutline}
                /> */}
                    <MenuLink
                        title={t('[REACT_ADD_CUSTOMER]')}

                        id="newCustomerFromCustomer"
                        icon={<Icon icon="clients_create" />}
                    />
                    <NewCustomerModal
                        parentId={customerId}
                        onDismiss={(e) => onMenuToggle?.(e as unknown as ReactClickEvent)}
                        trigger={"newCustomerFromCustomer"} />
                    <MenuSpacer /></> : <></>}
                <MenuLink
                    title={t('[REACT_CUSTOMERS_BELOW]')}
                    onClick={onMenuToggle}
                    link={generate('customer:customers', routeParams)}
                    icon={<Icon icon="clients_below" />}
                />
                <MenuSpacer />
                {permissionAllowed(permissions.createUser!) ?
                    // <MenuLink
                    //     title={t('COM_FACPMANAGEMENT_CUSTOMERS_CREATE_USER')}
                    //     onClick={onMenuToggle}
                    //     link={generate('customer:adduser', routeParams)}
                    //     icon={personAddOutline}
                    // />
                    <>
                        <MenuLink
                            title={t('COM_FACPMANAGEMENT_CUSTOMERS_CREATE_USER')}
                            id="newUserFromCustomer"
                            icon={<Icon icon="users_create" />}
                        />
                        <NewUserModal
                            customerId={customerId}
                            onDismiss={(e) => onMenuToggle?.(e as unknown as ReactClickEvent)}
                            trigger={"newUserFromCustomer"} /></>
                    : <></>}
                <MenuLink
                    title={t('[REACT_LIST_USERS]')}
                    onClick={onMenuToggle}
                    link={generate('customer:users', routeParams)}
                    icon={<Icon icon="users_show_all" />}
                />
                <MenuSpacer />
                {permissionAllowed(permissions.grantSystemAccess!) ?
                    // <MenuLink
                    //     title={t('COM_FACPMANAGEMENT_CUSTOMERS_CREATE_SYSTEM')}
                    //     onClick={onMenuToggle}
                    //     icon={<SystemStatusIcon height={24} width={24} />}
                    // />
                    <>
                        <MenuLink
                            title={t('COM_FACPMANAGEMENT_CUSTOMERS_CREATE_SYSTEM')}
                            id="newSystemFromCustomer"
                            icon={<Icon icon="systems_create" />}
                        />
                        <NewSystemModal
                            customerId={customerId}
                            onDismiss={(e) => onMenuToggle?.(e as unknown as ReactClickEvent)}
                            trigger={"newSystemFromCustomer"} /></>

                    : <></>}
                <MenuLink
                    title={t('[REACT_LIST_SYSTEMS]')}
                    onClick={onMenuToggle}
                    link={generate('customer:systems', routeParams)}
                    icon={<Icon icon="bmz_body" />}
                />
                <MenuSpacer />
                {(permissionAllowed(permissions.createCustomer!) && mayDelete) ? <MenuLink
                    title={t('[SID_MNU_HK_DELETE]')}
                    onClick={handleDelete}
                    icon={<Icon icon="delete" />}
                /> : <></>}
            </SidebarSection>
        </Sidebar>
    );

};

export default Customer;
